'use client';

import Hero from "../../components/Apps/DCC/Hero.jsx";
import About from "../../components/Apps/DCC/About.jsx";
import Features from "../../components/Apps/DCC/Features.jsx";
import WhyCUs from "../../components/Apps/DCC/WhyCUs.jsx";
import Brands from "../../components/Apps/DCC/Brands.jsx";
import ReqDemo from "../../components/Apps/DCC/ReqDemo.jsx";
import SectionType1 from "../../components/Sections/SectionType1.jsx";
// Keep the paused pricing component out of the public bundle.
// import Pricing from "../../components/Apps/DCC/Pricing.jsx";

const DCC = () => {
  return (
    <>
      <div className="absolute inset-0 pointer-events-none z-30">
        <div className="mt-2 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-52 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-10 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-20 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-0 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-20 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
      </div>

      <SectionType1>
        <Hero />
      </SectionType1>

      <SectionType1>
        <Brands />
      </SectionType1>

      <SectionType1>
        <About />
      </SectionType1>

      <SectionType1>
        <Features />
      </SectionType1>

      <SectionType1>
        <WhyCUs />
      </SectionType1>

      {/* <SectionType1 className="mt-32">
        <Pricing />
      </SectionType1> */}

      <SectionType1 className="-mb-48">
        <ReqDemo />
      </SectionType1>
    </>
  );
};

export default DCC;
